import { BucketObjectType } from "../types/BucketObjectType";
import { LegacyBucketFile, LegacyBucketFolder, LegacyBucketObject } from "./LegacyBucketObject";

// for internal use only
export type LegacyBucketObjectItem = LegacyBucketFolderItem | LegacyBucketFileItem;

export interface LegacyBucketFolderItem extends Omit<LegacyBucketFolder, "content"> {
    sizeInBytes: number;
    content: LegacyBucketObjectItem[];
    lastModified?: never;
}

export interface LegacyBucketFileItem extends LegacyBucketFile {
    content?: never;
}

export const mapToLegacyBucketObjectItem = (object: LegacyBucketObject): LegacyBucketObjectItem => {
    switch (object.type) {
        case BucketObjectType.File: {
            return {
                id: object.id,
                type: BucketObjectType.File,
                path: object.path,
                name: sanitizeBucketObjectName(object.name),
                sizeInBytes: object.sizeInBytes,
                lastModified: object.lastModified,
                isSelectable: object.isSelectable,
                isInactive: object.isInactive
            };
        }

        case BucketObjectType.Folder: {
            return {
                id: object.id,
                type: BucketObjectType.Folder,
                path: object.path,
                name: sanitizeBucketObjectName(object.name),
                sizeInBytes: calculateFolderSize(object),
                content: object.content.map(mapToLegacyBucketObjectItem),
                isSelectable: object.isSelectable
            };
        }
    }
};

const sanitizeBucketObjectName = (name: string): string => (name === "" ? "/" : name);

const calculateFolderSize = (folder: LegacyBucketFolder): number =>
    folder.content.reduce((size, child) => {
        if (child.type === BucketObjectType.Folder) {
            return size + calculateFolderSize(child);
        }

        return size + child.sizeInBytes;
    }, 0);
